import {api} from 'services/api';
import {Color} from 'types/colors';
import {ObjectId} from 'types/object-id';
import {ResponseData} from 'types/response-data';

const archiveColor = api.injectEndpoints({
  endpoints: builder => ({
    archiveColor: builder.mutation<Response, ArchiveColorRequest>({
      query: params => {
        return {
          method: 'DELETE',
          url: `colors/${params.id}`,
        };
      },
    }),
  }),
});

export type ArchiveColorRequest = {
  id: ObjectId;
};

type Response = ResponseData<Color>;

export const {useArchiveColorMutation} = archiveColor;
